export default __webpack_public_path__ + "static/media/ipsabook-web.ff8e64cd.jpg";